import React, { Component } from 'react';
import { connect } from 'react-redux';
import ExpandedFilterHeaderMobile from './ExpandedFilterHeaderMobile';
import SortByFilterMobile from './SortByFilterMobile';
import PrizeFilterMobile from './PrizeFilterMobile';
import ClubsFilterMobile from './ClubsFilterMobile';
import PlayerSkillsFilterMobile from './playerSkillsFilterMobile';
import PlayerSortByMob from './PlayerSortByMob';
import PlayerRecomendationMobileFilter from './PlayerRecomendationMobileFilter'

class ExpandedFiltersMobile extends Component {
    listenScroll = () => {
        if (this.filterBodyElem) {
            const Handler = (e) => {
                if (e.target.scrollTop > 5) {
                    this.filterBodyElem.classList.add('si-on-scroll-gradient');
                } else {
                    this.filterBodyElem.classList.remove('si-on-scroll-gradient');
                }
            };
            this.filterBodyElem.removeEventListener('scroll', Handler);
            this.filterBodyElem.addEventListener('scroll', Handler);
        }
    };

    componentDidMount() {
        this.listenScroll();

    }

    componentDidUpdate() {
        this.listenScroll();
    }

    render() {
        return <div className="si-sorting-wrap">
            <div className="si-container">
                <ExpandedFilterHeaderMobile />
                <div className="si-filter-body" ref={ (ref) => {
                    this.filterBodyElem = ref
                } }>

                    <SortByFilterMobile />
                    <PlayerSkillsFilterMobile />
                    <PrizeFilterMobile />
                    <ClubsFilterMobile />
                    <PlayerSortByMob />
                    { this.props.playerRecomendationKeys.length ? <PlayerRecomendationMobileFilter /> : null }
                </div>
                <div className="si-scrollshadow"></div>
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        playerRecomendationKeys: state.formationData.playerRecomendationKeys,

    };
};


export default connect(mapStateToProps)(ExpandedFiltersMobile);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/ExpandedFiltersMobile.js